module.exports = __webpack_public_path__ + "static/man_working-45319dcaf2239aa0717b40a42c04b9f3.svg";